// Export application layout configuration
export const AppLayoutConfig = {

    // Minimum supported desktop width
    minimumDesktopWidth: 768,

};